// app/javascript/controllers/dae20/page_nav_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "icon", "loader"]
  static classes = ["loading"]

  connect() {
    // Слушаем события Turbo для сброса состояния
    document.addEventListener('turbo:before-cache', this.resetAll.bind(this))
    document.addEventListener('turbo:load', this.resetAll.bind(this))
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.resetAll.bind(this))
    document.removeEventListener('turbo:load', this.resetAll.bind(this))
  }

  // Вызывается при клике на ссылку страницы
  navigate(event) {
    const link = event.currentTarget

    // Не показываем лоадер если это уже активная страница
    if (link.dataset.active === "true") {
      return
    }

    // Сбрасываем все остальные
    this.resetAll()

    // Добавляем состояние загрузки
    this.setLoading(link)
  }

  setLoading(link) {

    const wrapper = link.closest('[data-page-item]')
    console.log("wrapper===", wrapper)
    if (!wrapper) return
    console.log("link===", link)
    // Добавляем класс загрузки
    wrapper.classList.add('is-loading')
    link.classList.add('pointer-events-none')

    // Находим иконку и лоадер
    const icon = wrapper.querySelector('[data-icon]')
    const loader = wrapper.querySelector('[data-loader]')

    if (icon) icon.classList.add('hidden')
    if (loader) loader.classList.remove('hidden')
  }

  resetAll() {
    // Сбрасываем все элементы
    this.element.querySelectorAll('[data-page-item]').forEach(wrapper => {
      wrapper.classList.remove('is-loading')

      const link = wrapper.querySelector('a')
      const icon = wrapper.querySelector('[data-icon]')
      const loader = wrapper.querySelector('[data-loader]')

      if (link) link.classList.remove('pointer-events-none')
      if (icon) icon.classList.remove('hidden')
      if (loader) loader.classList.add('hidden')
    })
  }
}